import barba from '@barba/core';

export default class {
	constructor() {
		barba.hooks.afterOnce((data) => {
			this.Prism();
			this.Tw();
		});
		barba.hooks.after((data) => {
			this.Prism();
			this.Tw();
		});
	}
	Prism() {
		this.prismElems = document.querySelectorAll('pre.prism');
		if(this.prismElems.length > 0) {
			Prism.highlightAll();
		}
	}
	Tw() {
		if (typeof twttr === 'undefined') {
			let twitterjs = document.createElement("script");
			twitterjs.async = true;
			twitterjs.src = '//platform.twitter.com/widgets.js';
			document.getElementsByTagName('body')[0].appendChild(twitterjs);
		}
		else {
			twttr.widgets.load();
		}
	}

}